export const styles = (theme) => ({
  title: {
    // color: #000000;
    padding: 0,
    fontSize: "1.5rem",
    textAlign: "center",
    marginTop: "1.5rem",
    fontWeight: "500",
    lineHeight: "normal",
  },
  content: {
    fontSize: "1rem",
    fontWeight: "500",
  },
  contentExpire: {
    fontSize: "1rem",
    fontWeight: "500",
    color: "#909090",
  },
  numberExpire: {
    fontSize: "1rem",
    fontWeight: "500",
    color: "#292f48",
  },
  footerActiveCode: {
    justifyContent: "space-between",
    display: "flex",
  },
  footerEnterPhone: {
    justifyContent: "flex-end",
    display: "flex",
  },
  // footerActiveCode: {
  //     justifyContent: 'space-between',
  //     display: 'flex',
  // },
  DialogContent: {
    padding: "2.2rem 2.6rem 1.5rem",
  },
  boxCountryCode: {
    // padding: '12px 12px 0px 12px !important',
    display: "flex",
    alignItems: "flex-end",
    whiteSpace: "nowrap",
  },
  inputPhoneNumber: {
    border: "1px solid #d2d2d2",
    width: "98%",
    padding: "10px",
    "&:after": {
      borderBottomColor: "#fff",
    },
    "&:hover&:after ": {
      borderBottomColor: "#fff",
    },
  },
  // btnSent:{
  //     justifyContent: 'flex-end',
  //     display: 'flex',
  // }
  message: {
    overflowWrap: "break-word",
  },
  boxMess: {
    color: "black",
  },
  titleMess: {
    marginBottom: 16,
  },
  TextFieldGroup: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",

    "@media only screen and (min-width:600.98px) and (max-width:958px) ": {
      flexBasic: "100%",
      maxWidth: "100%",
    },
    "@media only screen and (min-width:480px) and (max-width:600px) ": {
      flexBasic: "100%",
      maxWidth: "100%",
    },
  },
  root: {
    padding: "24px",
    marginTop: "16px",
  },
  button: {
    minWidth: "max-content",
  },
  paperWidth: {
    width: "60%",
    maxWidth: "unset",
  },
});
